export namespace MicroApp {
    /** eg: Vue router navigate */
    export enum NavigateMethod {
        Push = 'push',
        Replace = 'replace',
        Back = 'back',
        Forward = 'forward',
        Go = 'go',
    }

    /** eg: Vue app */
    export interface IMicroApp {
        mount($el: HTMLElement | string): void;
        unmount(): void;
        onUnmount(callback: () => void): void;
    }

    /** eg: Vue router */
    export interface IMicroAppRouter {
        currentRoute: {
            value: {
                path: string;
                fullPath: string;
                meta: Record<string, unknown>;
            };
        };

        push(path: string): void;

        replace(path: string): void;

        go(n: number): void;

        afterEach(callback: () => void): void;
    }

    /** 微应用导航回调 */
    export interface IMicroNavigateCallback {
        /**
         * @param navigateMethod 导航方法
         * @param args 导航时的实际参数
         */
        (navigateMethod: NavigateMethod, ...args: unknown[]): void;
    }

    /** 主应用导航回调 */
    export interface IWebNavigateCallback {
        (nextFullPath: string): void;
    }
}
